'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    navDrawerFooterClassNames: function() {
        return navDrawerFooterClassNames;
    },
    useNavDrawerFooterStyles_unstable: function() {
        return useNavDrawerFooterStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactdrawer = require("@fluentui/react-drawer");
const navDrawerFooterClassNames = {
    root: 'fui-NavDrawerFooter'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1j1cbdv",
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62",
        Belr9w4: "f1j0q4x9"
    }
}, {
    d: [
        [
            ".f1j1cbdv{padding:var(--spacingVerticalXXS) var(--spacingHorizontalXS) var(--spacingVerticalXXS) var(--spacingVerticalXS) var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}",
        ".f1j0q4x9{row-gap:var(--spacingVerticalXXS);}"
    ]
});
const useNavDrawerFooterStyles_unstable = (state)=>{
    'use no memo';
    (0, _reactdrawer.useDrawerFooterStyles_unstable)(state);
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(navDrawerFooterClassNames.root, styles.root, state.root.className);
    return state;
};
